export type RuntimeConfig = {
  apiUrl: string;
  baseHref: string;
  keycloakUrl: string;
  keycloakRealm: string;
  keycloakClientId: string;
  oidcAuthority: string;
  oidcClientId: string;
  oidcScopes: string;
  ttsOnPrem: boolean;
  ttsEnvoyUrl?: string;
  defaultEnv: string;
  prodEnv: string;
  ttsEnvoyServiceUrls: Record<string, string>;
  appVersion: string;
};

type RawRuntime = Partial<RuntimeConfig> & Record<string, unknown>;
const rawRuntime: RawRuntime =
  (typeof window !== "undefined" ? window.__RUNTIME_CONFIG__ : undefined) ?? {};

const toString = (value: unknown, fallback = ""): string =>
  typeof value === "string" && value.length > 0 ? value : fallback;

const toBoolean = (value: unknown, fallback = false): boolean => {
  if (typeof value === "boolean") return value;
  if (typeof value === "string") return value.toLowerCase() === "true";
  return fallback;
};

export const runtimeConfig: RuntimeConfig = {
  apiUrl: toString(rawRuntime.apiUrl),
  baseHref: toString(rawRuntime.baseHref, "/"),
  keycloakUrl: toString(rawRuntime.keycloakUrl),
  keycloakRealm: toString(rawRuntime.keycloakRealm),
  keycloakClientId: toString(rawRuntime.keycloakClientId),
  oidcAuthority: toString(rawRuntime.oidcAuthority),
  oidcClientId: toString(rawRuntime.oidcClientId),
  oidcScopes: toString(rawRuntime.oidcScopes),
  ttsOnPrem: toBoolean(rawRuntime.ttsOnPrem),
  ttsEnvoyUrl: toString(rawRuntime.ttsEnvoyUrl),
  defaultEnv: toString(rawRuntime.defaultEnv),
  prodEnv: toString(rawRuntime.prodEnv),
  ttsEnvoyServiceUrls:
    rawRuntime.ttsEnvoyServiceUrls && typeof rawRuntime.ttsEnvoyServiceUrls === "object"
      ? (rawRuntime.ttsEnvoyServiceUrls as Record<string, string>)
      : {},
  appVersion: toString(rawRuntime.appVersion),
};

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: RawRuntime;
  }
}
